module.exports = __webpack_public_path__ + "static/media/cersei.63ac2d10.jpg";